import { Skeleton, Stack, Typography, useTheme } from "@mui/material";

const SKELETON_ROW_WIDTHS = ["55%", "40%", "65%", "45%", "60%", "35%"];

export const FlatRowSelectOptionListSkeleton = () => {
	const theme = useTheme();

	return (
		<Stack px={theme.spacingTokens.lg}>
			{SKELETON_ROW_WIDTHS.map((width, index) => (
				<Typography
					key={width}
					variant="body2"
					py={theme.spacingTokens.md}
					borderBottom={
						index === SKELETON_ROW_WIDTHS.length - 1
							? "none"
							: theme.colors.border.solid(theme.palette.grey[100])
					}
				>
					<Skeleton width={width} animation="wave" />
				</Typography>
			))}
		</Stack>
	);
};
